import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { VehicleConsultType } from './types';
import { fetchVehicleConsultService } from '../../services';

import moment from 'moment';

const initialState: VehicleConsultType = {
  isVehicleConsultLoading: false,
  vehicleConsultList: [],
  error: false,
  consultDateTime: ''
}

export const fetchVehicleConsult = createAsyncThunk(
  'vehicleConsult',
  async (plate: string) => {
    return await fetchVehicleConsultService(plate);
  }
);

export const vehicleConsultSlice = createSlice({
  name: 'vehicleConsult',
  initialState,
  reducers: {
    clearVehicleConsult() {
      return initialState;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchVehicleConsult.pending, state => {
      return {
        ...state,
        isVehicleConsultLoading: true,
        error: false,
        consultDateTime: ''
      }
    });
    builder.addCase(fetchVehicleConsult.fulfilled, (state, res) => {
      return {
        ...state,
        isVehicleConsultLoading: false,
        vehicleConsultList: res.payload,
        error: false,
        consultDateTime: ''
      }
    });
    builder.addCase(fetchVehicleConsult.rejected, state => {
      return {
        ...state,
        isVehicleConsultLoading: false,
        vehicleConsultList: [],
        error: true,
        consultDateTime: moment(moment.now()).format('DD/MM/YYYY HH:mm:ss')
      }
    });
  }
});

export const { clearVehicleConsult } = vehicleConsultSlice.actions;